<template>
  <div class="page-monitor">
    <ic-banner v-if="columnMeta" :data="columnMeta"></ic-banner>
    <div class="g-wrap card-wrap"></div>
  </div>
</template>

<script>
import News from "_c/News";
import Banner from "_c/Banner";
export default {
  data() {
    return {
      columnData: [],
      columnMeta: {
        name: "监控中心",
        enName: "monitor center"
      }
    };
  },
  created() {
    window.open("http://dev.qc.ve-city.com/monitor?code=zztzic", "_blank");
  },
  components: {
    [News.name]: News,
    [Banner.name]: Banner
  },
  methods: {
    loadData() {},
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-monitor {
}
</style>
